import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Translate from 'react-translate-component';
import { Link } from 'react-router-dom';
import { Dropdown, Menu, Layout, Badge } from 'antd';
import { prop, pluck, path } from 'ramda';
import { withRouter } from 'react-router';
import { MinusSquareOutlined } from '@ant-design/icons';

import { profile, approvalPerson, approvalProject, main } from 'constants/routes';
import { changeLanguage, collapseLeftMenu } from 'actions/appActions';
import { showCollapsible } from 'actions/modalActions';
import { logout, saveBackUrl } from 'actions/userActions';
import { getMenuCounters } from 'actions/asyncActions';
import { countersMapper } from 'mappers/userMapper';
import CustomIcon from 'components/common/CustomIcon';

import SettingsSidebar from 'components/sidebars/settings/SettingsSidebar';

const stateToProps = (state, props) => {
    const { headerTitle, leftMenu: { leftMenuPinned, leftMenuCollapsed }, collapsibleModals: { modals }} = state;
    const counters = getMenuCounters.selectData(state);

    return {
        headerTitle,
        leftMenuPinned,
        leftMenuCollapsed,
        counters: countersMapper(counters, props.user),
        modals,
    }
};

@connect(stateToProps, { logout, changeLanguage, collapseLeftMenu, saveBackUrl, showCollapsible })
@withRouter
export default class TopMenu extends Component {
    static propTypes = {
        user: PropTypes.object,
        logout: PropTypes.func.isRequired,
        changeLanguage: PropTypes.func.isRequired,
        collapseLeftMenu: PropTypes.func.isRequired,
        leftMenuCollapsed: PropTypes.bool,
        headerTitle: PropTypes.object,
        counters: PropTypes.object,
        getCompanyInfo: PropTypes.object,
        saveBackUrl: PropTypes.func.isRequired,
        modals: PropTypes.array.isRequired,
        showCollapsible: PropTypes.func.isRequired,
        noUser: PropTypes.bool,
        history: PropTypes.object,
    }

    state = {
        settingsSidebarCollapsed: true
    }

    setCollapsed = (value) => {
        this.setState({
            settingsSidebarCollapsed: value,
        });
    }

    userLogout = () => {
        const { logout, saveBackUrl } = this.props;

        saveBackUrl(false);
        logout();
    }

    getNotifications = (person, project, notdone) => (
        <Menu selectable={false}>
            <Menu.Item className="text-center" disabled>
                <Translate content="notify.title" />
            </Menu.Item>
            { person &&
                <Menu.Item>
                    <Link to={approvalPerson.stringify({ status: "inwork" })}>
                        <CustomIcon type="user-group" />
                        <Translate content="menu.approvalPerson" />
                        <span> ({ person })</span>
                    </Link>
                </Menu.Item>
            }
            { project &&
                <Menu.Item>
                    <Link to={approvalProject.stringify({ status: "inwork" })}>
                        <CustomIcon type="vacancy" />
                        <Translate content="menu.approvalProject" />
                        <span> ({ project })</span>
                    </Link>
                </Menu.Item>
            }
            { notdone &&
                <Menu.Item>
                    <Link to={main.stringify()}>
                        <CustomIcon type="notification" />
                        <Translate content="menu.notdone" />
                        <span> ({ notdone })</span>
                    </Link>
                </Menu.Item>
            }
            { !person && !project && !notdone &&
                <Menu.Item>
                    <Translate content="notify.emptyList" disabled/>
                </Menu.Item>
            }
        </Menu>
    );

    getUserMenu = () => {
        const { user, getCompanyInfo: { data } } = this.props;

        return (
            <Menu selectable={false}>
                <Menu.Item className="text-center" disabled>
                    {user.username}
                </Menu.Item>
                <Menu.Item>
                    <Link to={profile.path}>
                        <Translate content="menu.profile" />
                    </Link>
                </Menu.Item>
                <Menu.Divider />
                <Menu.Item>
                    <Translate content={data.sso ? 'menu.relog' : 'menu.logout'} component='a' onClick={this.userLogout} />
                </Menu.Item>
            </Menu>
        );
    }

    render() {
        const { user, collapseLeftMenu, leftMenuCollapsed, headerTitle, counters, modals, showCollapsible, noUser, history } = this.props;
        const { person = 0, project = 0 } = pluck('inwork', counters);
        const notdone = path(['notdone', 'count'], counters) || 0;
        const totalNotifications = project + person + notdone;

        return (
            <div>
                <Layout.Header className="header">
                    <div className="logo" onClick={() => noUser ? history.push('/') : collapseLeftMenu(!leftMenuCollapsed)}/>
                    <div className="title">
                        <Translate content={prop('title', headerTitle)} with={prop('params', headerTitle)} />
                    </div>
                    <Menu
                        className="menu"
                        theme="dark"
                        mode="horizontal"
                        selectable={false}
                    >
                        { !!modals.length &&
                            <Menu.Item key='modals' className="extended-click-area-item">
                                <div>
                                    <Badge count={modals.length} showZero={false} overflowCount={999} onClick={showCollapsible}>
                                        <MinusSquareOutlined />
                                    </Badge>
                                </div>
                            </Menu.Item>
                        }
                        { !noUser && path(['permissions', 'web'], user) &&
                            <Menu.Item key="notification" className="extended-click-area-item">
                                <Dropdown trigger={['click']}
                                          placement='bottomRight'
                                          overlay={this.getNotifications(person, project, notdone)}>
                                    <div>
                                        <Badge count={totalNotifications} showZero={false} overflowCount={999} >
                                            <CustomIcon type="notification" />
                                        </Badge>
                                    </div>
                                </Dropdown>
                            </Menu.Item>
                        }
                        { !noUser &&
                            <Menu.Item key="profile" className="extended-click-area-item">
                                <Dropdown trigger={['click']}
                                          placement='bottomRight'
                                          overlay={this.getUserMenu()}>
                                    <div ref={(node) => this.dropdown = node}>
                                        <CustomIcon type="profile" />
                                    </div>
                                </Dropdown>
                            </Menu.Item>
                        }
                        <Menu.Item key="settings" className="extended-click-area-item settings-item">
                            <div onClick={() => this.setCollapsed(!this.state.settingsSidebarCollapsed)}>
                                <CustomIcon type="shape"
                                    className="trigger"
                                />
                            </div>
                        </Menu.Item>
                    </Menu>
                </Layout.Header>
                <Layout.Sider
                    trigger={null}
                    collapsible
                    collapsed={this.state.settingsSidebarCollapsed}
                    collapsedWidth={0}
                    width={387}
                    className="right-sidebar-fixed"
                >
                    { !this.state.settingsSidebarCollapsed && (
                        <SettingsSidebar
                            withoutPinLeft={noUser}
                            close={() => this.setCollapsed(true)}
                        />
                    )}
                </Layout.Sider>
            </div>
        );
    }
}
